import React from 'react';
import { Modal, Typography, Input, Button, Alert, Tooltip } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import { ReadOnlyGuard, useReadOnly } from '@spark';
import { getFunctionSignature } from './utils';
import { getParserSchema } from './parserSchemas';
import ValidationAlert from './ValidationAlert';

const { TextArea } = Input;

const ResponseParserInspectLogicModal = ({
    open,
    onClose,
    taskType,
    isMultilabel,
    userCode,
    onCodeChange,
    handleKeyDown,
    validationResult,
    validationLoading,
    onValidate,
    teacher,
    // Raise above other overlays (e.g. SparkModalPortal at 1300).
    zIndex,
}) => {
    const { readOnly } = useReadOnly();
    const functionSignature = getFunctionSignature(taskType);
    const schemaSpec = getParserSchema(taskType, isMultilabel);

    return (
        <Modal
            open={open}
            onCancel={onClose}
            zIndex={zIndex}
            width={920}
            title={<div className='fs-unmask' style={{ marginLeft: '12px' }}>Inspect logic</div>}
            className="response-parser-drawer"
            destroyOnClose={false}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    <div className='fs-unmask'>Cancel</div>
                </Button>,
                <ReadOnlyGuard key="run">
                    <Tooltip title="Check if the logic returns the expected output">
                        <Button
                            key="run"
                            type="primary"
                            onClick={() => onValidate(true)}
                            loading={validationLoading}
                        >
                            <div className='fs-unmask'>Validate</div>
                        </Button>
                    </Tooltip>
                </ReadOnlyGuard>
            ]}
        >
            <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <Typography.Title className='fs-unmask' level={5} style={{ marginTop: 0, marginLeft: 12 }}>
                        Logic
                    </Typography.Title>
                    <div style={{ border: '1px solid #d9d9d9', paddingRight: 12, paddingLeft: 12, paddingTop: 8, paddingBottom: 8, borderRadius: 8 }}>
                        <div className='fs-unmask' style={{
                            padding: 12,
                            border: '1px solid #d9d9d9',
                            borderRadius: 8,
                            background: '#fafafa',
                            font: 'Inter',
                            fontSize: 13,
                            whiteSpace: 'pre-wrap',
                            marginBottom: 12,
                            paddingTop: 22,
                            paddingBottom: 22,
                        }}>{functionSignature}</div>
                        <TextArea
                            value={userCode}
                            onChange={(e) => onCodeChange(e.target.value)}
                            onKeyDown={handleKeyDown}
                            disabled={readOnly}
                            style={{ border: "none", padding: 0, font: 'Inter', fontSize: 13 }}
                            autoSize={{ minRows: 11, maxRows: 10 }}
                        />

                    </div>
                </div>
                <div
                    style={{
                        width: 360,
                        minWidth: 300,
                        height: 'fit-content',
                    }}
                >
                    <Typography.Title level={5} style={{ marginTop: 0 }}>
                        {schemaSpec.title}
                    </Typography.Title>
                    <pre
                        style={{
                            background: '#fafafa',
                            borderRadius: 8,
                            padding: 12,
                            border: '1px solid #e4e4e4',
                            fontFamily: 'JetBrains Mono, Monaco, monospace',
                            fontSize: 13,
                            whiteSpace: 'pre-wrap',
                            marginBottom: 12,
                            color: "#898989",
                        }}
                    >
                        {schemaSpec.schema}
                    </pre>
                    <Alert
                        type="info"
                        icon={<InfoCircleFilled style={{ color: '#1677ff', marginTop: 2 }} />}
                        showIcon
                        message={<div style={{ font: "Inter", fontSize: 13 }}>{schemaSpec.info}</div>}
                        style={{ background: '#f0f6ff', border: '1px solid #c7deff', color: "#898989", display: 'flex', alignItems: 'flex-start', marginTop: 10 }}
                    />
                </div>
            </div>

            {validationResult && (
                <div className="response-parser-drawer__validation">
                    <ValidationAlert
                        validationResult={validationResult}
                        taskType={taskType}
                        isMultilabel={isMultilabel}
                    />
                </div>
            )}
        </Modal>
    );
};

export default ResponseParserInspectLogicModal;